import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document, BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { Text } from 'components/Text'
import { BlogImage } from 'features/Blog/components/BlogImage/BlogImage'
import { PostContentRoot, Span } from './PostContent.styles'

export type PostContentType = Document

export type PostContentProps = {
  content: PostContentType
}

export const PostContent = ({ content }: PostContentProps) => {
  return (
    <PostContentRoot>
      {documentToReactComponents(content, {
        renderMark: {
          [MARKS.BOLD]: (text) => <Span weight="medium">{text}</Span>,
          [MARKS.UNDERLINE]: (text) => <Span underline>{text}</Span>,
          [MARKS.ITALIC]: (text) => <Span italic>{text}</Span>,
        },
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => (
            <Text display="block" as="p" size="headline">
              {children}
            </Text>
          ),
          [BLOCKS.HEADING_1]: (_, children) => (
            <Text as="h1" size="h1" display="block">
              {children}
            </Text>
          ),
          [BLOCKS.HEADING_2]: (_, children) => (
            <Text
              as="h2"
              size="h2"
              display="block"
              css={{ '&:not(:first-child)': { marginTop: '$10' }, marginBottom: '$2' }}
            >
              {children}
            </Text>
          ),
          [BLOCKS.HEADING_3]: (_, children) => (
            <Text as="h3" size="h3" display="block">
              {children}
            </Text>
          ),
          [BLOCKS.HEADING_4]: (_, children) => (
            <Text as="h4" size="h4" display="block">
              {children}
            </Text>
          ),
          [BLOCKS.HEADING_5]: (_, children) => (
            <Text as="h5" size="h5" display="block">
              {children}
            </Text>
          ),
          [BLOCKS.HEADING_6]: (_, children) => (
            <Text as="h6" size="h5" display="block">
              {children}
            </Text>
          ),
          [BLOCKS.EMBEDDED_ASSET]: (node) => (
            <BlogImage css={{ marginTop: '$3' }} content={node.data.target} />
          ),
          [INLINES.HYPERLINK]: ({ data }, children) => (
            <Span as="a" underline href={data.uri}>
              {children}
            </Span>
          ),
        },
      })}
    </PostContentRoot>
  )
}
